let e, n;
function r() {
  var o;
  return e !== void 0 || (typeof window != "undefined" && window.performance ? (e = !0, n = window.performance) : typeof globalThis != "undefined" && (!((o = globalThis.perf_hooks) === null || o === void 0) && o.performance) ? (e = !0, n = globalThis.perf_hooks.performance) : e = !1), e;
}
function f() {
  return r() ? n.now() : Date.now();
}
export {
  r as isPerformanceSupported,
  f as now
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@vue_devtools-api@6.6.4/~/@vue/devtools-api/lib/esm/time.js
// module id = 1365
// module chunks = 67